import { Injectable } from '@angular/core';
import { CustomerDetails } from '@domgen/dgx-fe-common';
import { CheckoutFacade } from '@checkout/data-access';
import { combineLatest, Observable } from 'rxjs';

export interface ViewModel {
  customerDetails?: CustomerDetails;
}

@Injectable()
export class CheckoutCustomerDetailsComponentService {
  readonly vm$: Observable<ViewModel> = combineLatest({
    customerDetails: this.checkoutFacade.customerDetails$,
  });

  constructor(private readonly checkoutFacade: CheckoutFacade) {}
}
